
import { defineComponent } from "vue";
import IndexButton from "@/index/IndexButton.vue";
import ZlotyIcon from "@/components/icons/ZlotyIcon.vue";

export default defineComponent({
  components: {
    IndexButton,
    ZlotyIcon,
  },
});
